import { LiquidEngineService } from '../../services/liquidEngineService';
import { BlockInstanceType } from '../../blocks/BlockInterface';
import { getBatchVariablesFromPropertyValue } from './getBatchVariablesFromPropertyValue';
import { BlockPropertyNameGetter } from './types';

export class BlockPropertyTemplateVariableNameGetter
  implements BlockPropertyNameGetter
{
  constructor(protected liquidEngineService = new LiquidEngineService()) {}

  get(
    block: BlockInstanceType,
    blockPropertyName: string,
    _parents: Array<BlockInstanceType> = []
  ): string {
    const propertyValue = block.properties[blockPropertyName];
    const extractedValue = getBatchVariablesFromPropertyValue(propertyValue);

    return this.liquidEngineService.getTemplateVariableNameWithBlacklist(
      extractedValue
    );
  }
}
